import { render, staticRenderFns } from "./userprofile.vue?vue&type=template&id=646b620c&scoped=true&lang=html"
import script from "./userprofile.vue?vue&type=script&lang=js"
export * from "./userprofile.vue?vue&type=script&lang=js"
import style0 from "./userprofile.vue?vue&type=style&index=0&id=646b620c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646b620c",
  null
  
)

export default component.exports